import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../hooks/useAuthStore";

import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { Key, LogOut } from 'react-feather';
import { Menu } from 'react-feather'


const drawerWidth = 240;

const getBrand = (routes) => {
    
    let brandName = "Default Brand";
    Object.entries(routes).forEach(([prop, route]) => {
        route.map((item, key) =>{
            if ( item.subRoutes.length === 0 ){
                if (window.location.href.indexOf(item.path) !== -1) {
                    brandName = item.name;
                }
                return null;
            }else{
                item.subRoutes.map((subItem, subKey) => {
                if (window.location.href.indexOf(subItem.path) !== -1) {
                    brandName = subItem.name;
                }
                return null;
                })
            }
        })
    })
    return brandName;
};

export const CustomNavbar = (props) => {

    const { startLogout, user } = useAuthStore()
    const navigate = useNavigate();

    const goToChangePassword = () => {
        navigate("/cambiar-clave");
    };
    
    const {
        routes,
        handleDrawerToggle
    } = props

    return (
        <AppBar
            position="fixed"
            sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            }}
            style={{background: '#f4f3ef', color: '#66615b'}}
        >
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ mr: 2, display: { sm: 'none' } }}
                >
                    <Menu />
                </IconButton>
                <div className="d-flex justify-content-between align-items-center w-100">
                    <Typography variant="h6" noWrap component="div">
                        {getBrand(routes)}
                    </Typography>
                    <span>
                        <IconButton aria-label="delete" size="small" onClick={goToChangePassword}>
                            <Typography variant='caption' marginRight={2}>
                                CAMBIAR CLAVE
                            </Typography>
                            <Key/>
                        </IconButton>
                        <IconButton aria-label="delete" size="small" onClick={startLogout}>
                            <Typography variant='caption' marginRight={2}>
                                {user.name}
                            </Typography>
                            <LogOut/>
                        </IconButton>
                    </span>
                    
                </div>
            </Toolbar>
        </AppBar>
    );
}

